import { useState } from "react";
import { Menu, X } from "lucide-react";
import { DiamondMark } from "./DiamondMark";

const LINKS = [
  { label: "Services", href: "#services", id: "nav-services-link" },
  { label: "Events", href: "#events", id: "nav-events-link" },
  { label: "Catering", href: "#catering", id: "nav-catering-link" },
  { label: "Contact", href: "#booking", id: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#FDFBF7]/70 backdrop-blur-xl border-b border-[#E5D3B3]/40">
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-12 h-20">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3 group">
          <DiamondMark className="w-7 h-7 text-[#D8A7A1] transition-transform duration-500 group-hover:rotate-180" />
          <span className="font-serif text-lg tracking-[0.18em] uppercase">
            The Diamond Effect <span className="italic text-[#D8A7A1]">Affairs</span>
          </span>
        </a>
        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              className="text-xs uppercase tracking-[0.22em] text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#booking"
            data-testid="nav-book-button"
            className="text-xs uppercase tracking-[0.22em] border border-[#D8A7A1] text-foreground px-6 py-3 rounded-full hover:bg-[#D8A7A1] hover:text-[#FDFBF7] transition-colors duration-300"
          >
            Book an Affair
          </a>
        </div>
        <button
          data-testid="nav-mobile-menu-button"
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </nav>
      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-[#E5D3B3]/40 bg-[#FDFBF7]/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.id}-mobile`}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.22em] text-muted-foreground"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
